export { Tabs } from './Tabs';
export { DefaultTabBar } from './DefaultTabBar';


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-tabs/es/index.js
// module id = 215
// module chunks = 0